import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class OpenIdConnectConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getIsMitIdEnabled(): boolean {
		return this.configService.get((x) => x.core.dgaAuthTransaction?.isMitIdEnabled, false);
	}
}
